import type { AppState } from '../state/appState.js';
import { createStateSnapshot, restoreStateSnapshot } from '../state/snapshot.js';

const FILE_STORAGE_KEY = 'fluveria-document';

export function saveFileToBrowserStorage(appState: AppState, storage: Storage = localStorage): void {
  storage.setItem(FILE_STORAGE_KEY, JSON.stringify(createStateSnapshot(appState)));
}

export function loadFileFromBrowserStorage(appState: AppState, storage: Storage = localStorage): boolean {
  const data = storage.getItem(FILE_STORAGE_KEY);
  if (!data) return false;

  try {
    restoreStateSnapshot(appState, JSON.parse(data));
    return true;
  } catch {
    return false;
  }
}
